import { createContext, useMemo, ReactNode } from 'react';

import { useResource } from 'react-resource-router';

import { MenuItem } from 'src/components/navigation/src/types';
import { forgeProjectNavigationResource } from 'src/sections/project/forge-project-navigation-resource';
import { forgeRepositoryNavigationResource } from 'src/sections/repository/forge-repository-navigation-resource';
import { forgeWorkspaceNavigationResource } from 'src/sections/workspace/forge-workspace-navigation-resource';

export type ForgeAppsContextType = {
  personalSettingsForgeMenuItems: MenuItem[];
  workspaceForgeMenuItems: MenuItem[];
};

export const ForgeAppsContext = createContext<ForgeAppsContextType>({
  personalSettingsForgeMenuItems: [],
  workspaceForgeMenuItems: [],
});

export const ForgeAppsProvider = ({ children }: { children: ReactNode }) => {
  const { data: workspaceForgeMenuItems } = useResource(
    forgeWorkspaceNavigationResource
  );
  const { data: projectForgeMenuItems } = useResource(
    forgeProjectNavigationResource
  );

  const { data: repoForgeMenuItems } = useResource(
    forgeRepositoryNavigationResource
  );

  const providerValue = useMemo(
    () => ({
      personalSettingsForgeMenuItems:
        workspaceForgeMenuItems?.personalSettingsForgeMenuItems ||
        projectForgeMenuItems?.personalSettingsForgeMenuItems ||
        repoForgeMenuItems?.personalSettingsForgeMenuItems ||
        [],
      workspaceForgeMenuItems:
        workspaceForgeMenuItems?.forgeMenuItems ||
        projectForgeMenuItems?.workspaceForgeMenuItems ||
        repoForgeMenuItems?.workspaceForgeMenuItems ||
        [],
    }),
    [workspaceForgeMenuItems, projectForgeMenuItems, repoForgeMenuItems]
  );
  return (
    <ForgeAppsContext.Provider value={providerValue}>
      {children}
    </ForgeAppsContext.Provider>
  );
};
